import * as types from "./../types";

const initState = {
  cardDetails: {
    ffnNo: "",
    imaNo: "",
    cardReferralCode: "",
  },
  error: null,
};

const CardDetailsReducer = (state = initState, actions) => {
  switch (actions.type) {
    case types.GET_CARD_DETAILS:
      return {
        ...state,
        cardDetails: actions.cardPath,
        error: actions.error,
      };
      case types.SAVE_NW_DATA:
      return {
        ...state,
        
          nwList:actions.payload.data.products,
        
      }
      case types.RESET_NW_DATA:
        return {
          ...state,
          
            nwList:actions.payload,
          
        }
        case types.SAVE_NETWORK_CARDTYPE:
          return {
            ...state,
            selectedNwCardType:actions.payload,
          }
    default:
      return state;
  }
};

export default CardDetailsReducer;
